import EvaluationLaws from '../../../../../components/States/EvaluationLaws';
import { Subdimensiones } from '../../../../../interfaces/Evaluations';

interface Props {
    subdimensiones: Subdimensiones;
    allYearsList: string[];
    allLawsByYearMap: { [year: string]: { law: string; url?: string | null }[] };
}

const EvaluationSingleRow = ({ subdimensiones, allYearsList, allLawsByYearMap }: Props) => {
    return (
        <div className="scrollable-body flex flex-col">
            <div className="flex flex-row gap-4 border-t border-system-light-50 min-w-fit px-3">
                {allYearsList.map((year) => (
                    <div key={year} className="flex gap-4">
                        {allLawsByYearMap[year]?.map((law, lawIndex) => {
                            const evaluation = subdimensiones.evaluaciones?.[year]?.find(
                                (evalItem) => evalItem.nombre === law.law
                            );
                            return (
                                <div key={lawIndex} className=" w-[120px] sm:w-[140px] h-[56px] flex flex-col justify-center items-center">
                                    <EvaluationLaws evaluacion={evaluation?.evaluacion ?? null} />
                                </div>
                            );
                        })}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default EvaluationSingleRow;